var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Box } from "@mui/material";
import { isArray } from "@sequentech/ui-core";
import { useEffect, useState } from "react";
import { useInput } from "react-admin";
import DraggableElement from "../DraggableElement";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
var CustomOrderInput = function (_a) {
    var source = _a.source;
    var _b = useInput({ source: source }).field, onChange = _b.onChange, value = _b.value;
    var _c = useState(value !== null && value !== void 0 ? value : []), data = _c[0], setData = _c[1];
    var _d = useState(-1), dragIndex = _d[0], setDragIndex = _d[1];
    var _e = useState(null), overIndex = _e[0], setOverIndex = _e[1];
    var aliasRenderer = useAliasRenderer();
    useEffect(function () {
        if (isArray(value) && value.length > 0) {
            setData(value);
        }
    }, [value, setData, isArray]);
    var onDragStart = function (_event, index) {
        setDragIndex(index);
    };
    var onDragOver = function (event, index) {
        event.preventDefault();
        setOverIndex(index);
    };
    var onDragEnd = function () {
        setOverIndex(-1);
        setDragIndex(-1);
    };
    var onDrop = function (event, dropIndex) {
        event.preventDefault();
        if (dragIndex === -1 || dragIndex === dropIndex) {
            return;
        }
        setData(function (prev) {
            if (!prev || !prev.length)
                return [];
            var reorderedItems = __spreadArray([], prev, true);
            var draggedItem = reorderedItems.splice(dragIndex, 1)[0];
            reorderedItems.splice(dropIndex, 0, draggedItem);
            onChange(reorderedItems); // Update the form value
            return reorderedItems;
        });
        onDragEnd();
    };
    return (_jsx(Box, { children: data === null || data === void 0 ? void 0 : data.map(function (lineItem, index) {
            return (lineItem && (_jsx(DraggableElement, { index: index, id: lineItem.id, name: aliasRenderer(lineItem), onDragStart: onDragStart, onDragOver: onDragOver, onDrop: onDrop, isOver: overIndex === index }, lineItem.id)));
        }) }));
};
export default CustomOrderInput;
